import React from "react";
import { Col, Nav, Row } from "react-bootstrap";
import Logo from "../assets/VK Logo Foo.png";
import { LinkContainer } from "react-router-bootstrap";

const Footer = () => {
  return (
    <>
      {/* <Row className="mx-0 footer px-5 pt-5 pb-3">
        <Col md={3}>
          <img src={Logo} alt="Logo" />
          <p className="text-secondary pt-5 mb-0">Connect with us</p>
          <p className="fs-5 text-secondary">
            <i className="fab fa-facebook-square"></i>&nbsp;&nbsp;
            <i className="fab fa-twitter-square"></i>&nbsp;&nbsp;
            <i className="fab fa-linkedin"></i>&nbsp;&nbsp;
            <i className="fas fa-envelope-square"></i>
          </p>
        </Col>
        <Col md={3}>
          <h5 className="fh5">FOR CANDIDATE</h5>
          <Nav className="flex-column">
            <Nav.Link href="#" className="px-0 py-1">
              Upload Resume
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Candidate Dashboard
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              My Account
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Value Plans
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Your Jobs
            </Nav.Link>
          </Nav>
        </Col>
        <Col md={3}>
          <h5 className="fh5">FOR EMPLOYERS</h5>
          <Nav className="flex-column">
            <Nav.Link href="#" className="px-0 py-1">
              Post A Job
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Employer Dashboard
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              My Account
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Job Packages
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Browse Candidates
            </Nav.Link>
          </Nav>
        </Col>
        <Col md={3}>
          <h5 className="fh5">INFORMATION</h5>
          <Nav className="flex-column">
            <Nav.Link href="#" className="px-0 py-1">
              About Us
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Terms & Conditions
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Privacy Policy
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              Careers with Us
            </Nav.Link>
            <Nav.Link href="#" className="px-0 py-1">
              FAQs
            </Nav.Link>
          </Nav>
        </Col>
      </Row> */}
      <Row className="foot mx-0 stud-test py-4">
        <Col>
          <p className="mb-0 py-2">© 2023 HT Academy. All Rights Reserved.</p>
        </Col>
        <Col className="text-end">
          <Nav className="align-items-center float-end">
            <LinkContainer to={"/careers"} className="px-2">
              <Nav.Link>Careers</Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/contact"} className="px-2">
              <Nav.Link>Contact Us</Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/privacy"} className="px-2">
              <Nav.Link>Privacy Policy</Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/terms"} className="px-2">
              <Nav.Link>Terms of use</Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/cancellation"} className="px-2">
              <Nav.Link>Cancellation & Refund Policy</Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/shipping"} className="px-2">
              <Nav.Link>Shipping & Delivery Policy</Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/careers"} className="px-2">
              <Nav.Link>
                <i className="fab fa-facebook-square"></i>
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/careers"} className="px-2">
              <Nav.Link>
                <i className="fab fa-twitter-square"></i>
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to={"/careers"} className="px-2">
              <Nav.Link>
                <i className="fas fa-envelope-square"></i>
              </Nav.Link>
            </LinkContainer>
          </Nav>
        </Col>
      </Row>
    </>
  );
};

export default Footer;
